import { connect } from "react-redux";

import Route from "./Route";

import { 
  toggleLegendPopup
} from "../../store/actions";


import {excludeCity, toggleShowPassingCitiesInRouteDetails} from "../../store/actions";

const mapStateToProps = state => ({
  routeSegments: state.metrics.routeSegments,
  routeRequest: state.routeRequest,
  showPassingCitiesInRouteDetails: state.showPassingCitiesInRouteDetails,
  showLegendPopup: state.showLegendPopup
});

const mapDispatchToProps = dispatch => ({
  toggleShowPassingCitiesInRouteDetails: enabled => dispatch(toggleShowPassingCitiesInRouteDetails(enabled)),
  excludeCity: city => dispatch(excludeCity(city)),
  openLegendPopup: () => dispatch(toggleLegendPopup(true)),
  closeLegendPopup: () => dispatch(toggleLegendPopup(false))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Route);
